<div class="mt-20 bg-white radius-10">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Candidatures</p>
        <p class="no-margin dark-gray">Ajoutez les candidats par collège.</p>
      </div>
    </div>
  </div>

  <div class="radius-10 p-20">
    <h2 class="no-margin mb-10 light-blue text-md">Collège {{index}}</h2>
    <div class="flex gap-10 mb-10" style="display: grid; grid-template-columns: repeat(5, 1fr);">
      <v8te-active-button *ngFor="let union of activeUnion; let i = index"
        [buttonText]="union.shortName + ' ' + (getUnionCandidates(union)?.titularCandidates.length || 0) + ' / ' + college.seats"
        [primaryColor]="activeList == i ? '#1990FF' : '#ffffff'" [secondaryColor]="'#1990FF'"
        [textPrimaryColor]="activeList == i ? '#ffffff' : '#1990FF'" [width]="150" [height]="50"
        (click)="logSelected(i)"></v8te-active-button>
    </div>

    <!-- Affichage de l'union active seulement -->
    <div *ngIf="activeUnion[activeList]" class="mb-20">
      <h3 class="light-blue mb-10">{{activeUnion[activeList].shortName}}</h3>

      <!-- Section Titulaires -->
      <div class="radius-10 border-gray mb-10">
        <div class="bg-pastel-blue p-20" style="border-radius: 10px 10px 0 0;">
          <p class="dark-blue bold no-margin">
            Candidat titulaire
            {{getUnionCandidates(activeUnion[activeList])?.titularCandidates.length || 0}} /
            {{college.seats}}
          </p>
        </div>
        <div class="p-20">
          <div *ngIf="isValidated && carence[activeUnion[activeList].shortName]" class="mb-10 p-10 radius-5"
            style="background: #FEF2F2; border: 1px solid #FCA5A5;">
            <p class="no-margin text-center strong-red bold">Carence de candidature(s)</p>
          </div>

          <div *ngIf="!carence[activeUnion[activeList].shortName]">
            <div *ngFor="let candidate of getUnionCandidates(activeUnion[activeList])?.titularCandidates"
              class="flex content-between align-items-center mb-10">
              <div class="flex gap-10 align-items-center">
                <select *ngIf="!isValidated" [ngModel]="candidate.gender || 'H'"
                  (ngModelChange)="onGenderChange(candidate, $event)" class="p-5 radius-5"
                  style="border: solid 1px #E8E8E8;">
                  <option value="H">H</option>
                  <option value="F">F</option>
                </select>
                <p *ngIf="isValidated" class="no-margin bold" style="min-width: 30px;">{{candidate.gender || 'H'}}</p>
                <p class="no-margin">{{candidate.firstName}} {{candidate.lastName}}</p>
              </div>
              <div class="flex gap-10 align-items-center">
                <img *ngIf="!isValidated"
                  (click)="unselectCandidate(candidate, 'titular', activeUnion[activeList].shortName)"
                  src="assets/close_24px.svg" alt="" class="pointer">
              </div>
            </div>
          </div>

          <button *ngIf="getUnionCandidates(activeUnion[activeList])?.titularCandidates.length < college.seats && !showTitularSearch[activeUnion[activeList].shortName] && !isValidated"
            class="flex gap-10 align-items-center content-center p-20 radius-10 pointer w-full bg-white light-blue"
            style="border: dashed 1px #1990FF;" [disabled]="carence[activeUnion[activeList].shortName]"
            [style.opacity]="carence[activeUnion[activeList].shortName] ? '0.5' : '1'"
            [style.cursor]="carence[activeUnion[activeList].shortName] ? 'not-allowed' : 'pointer'"
            (click)="!carence[activeUnion[activeList].shortName] && addTitularCandidate(activeUnion[activeList].shortName)">
            <span class="bold">+</span> Ajouter un candidat titulaire
          </button>

          <div
            *ngIf="showTitularSearch[activeUnion[activeList].shortName] && !carence[activeUnion[activeList].shortName]">
            <div class="w-full border-box flex gap-10 align-items-center">
              <input type="text" [(ngModel)]="titularSearchTerm[activeUnion[activeList].shortName]"
                class="w-full p-10 radius-10 border-box" style="border: solid 1px #1990FF;"
                placeholder="Rechercher un candidat..." />
              <img src="assets/close_24px.svg" alt="close" class="pointer"
                (click)="showTitularSearch[activeUnion[activeList].shortName] = false">
            </div>

            <div class="mt-10" style="max-height: 300px; overflow-y: auto;">
              <div
                *ngFor="let candidate of getFilteredCandidates(titularSearchTerm[activeUnion[activeList].shortName], activeUnion[activeList].shortName, 'titular')"
                class="p-10 pointer radius-5 mb-5" style="border: solid 1px #E8E8E8; background: #FAFAFA;"
                (click)="selectCandidate(candidate, 'titular', activeUnion[activeList].shortName)">
                <p class="no-margin bold">{{candidate.firstName}} {{candidate.lastName}}</p>
                <p class="no-margin small-text gray">{{candidate.email}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="!isValidated" class="flex align-items-center gap-10 mt-10">
            <label class="dark-blue no-margin">
              <input type="checkbox" [(ngModel)]="carence[activeUnion[activeList].shortName]"
                (ngModelChange)="onCarenceChange(activeUnion[activeList].shortName, $event)">
              Carence
            </label>
          </div>

        </div>
      </div>

      <!-- Section Suppléants -->
      <div class="radius-10 border-gray">
        <div class="bg-pastel-yellow p-20" style="border-radius: 10px 10px 0 0;">
          <p class="dark-blue bold no-margin">Candidat suppléant
            {{getUnionCandidates(activeUnion[activeList])?.substituteCandidates.length || 0}} /
            {{college.substituteSeats}}
          </p>
        </div>
        <div class="p-20">
          <div *ngIf="isValidated && carenceSubstitute[activeUnion[activeList].shortName]" class="mb-10 p-10 radius-5"
            style="background: #FEF2F2; border: 1px solid #FCA5A5;">
            <p class="no-margin text-center strong-red bold">Liste en carence</p>
          </div>

          <div *ngIf="!carenceSubstitute[activeUnion[activeList].shortName]">
            <div *ngFor="let candidate of getUnionCandidates(activeUnion[activeList])?.substituteCandidates"
              class="flex content-between align-items-center mb-10">
              <div class="flex gap-10 align-items-center">
                <select *ngIf="!isValidated" [ngModel]="candidate.gender || 'H'"
                  (ngModelChange)="onGenderChange(candidate, $event)" class="p-5 radius-5"
                  style="border: solid 1px #E8E8E8;">
                  <option value="H">H</option>
                  <option value="F">F</option>
                </select>
                <p *ngIf="isValidated" class="no-margin bold" style="min-width: 30px;">{{candidate.gender || 'H'}}</p>
                <p class="no-margin">{{candidate.firstName}} {{candidate.lastName}}</p>
              </div>
              <div class="flex gap-10 align-items-center">
                <img *ngIf="!isValidated"
                  (click)="unselectCandidate(candidate, 'substitute', activeUnion[activeList].shortName)"
                  src="assets/close_24px.svg" alt="" class="pointer">
              </div>
            </div>
          </div>

          <button *ngIf="getUnionCandidates(activeUnion[activeList])?.substituteCandidates.length < college.substituteSeats && !showSubstituteSearch[activeUnion[activeList].shortName] && !isValidated"
            class="flex gap-10 align-items-center content-center p-20 radius-10 pointer w-full bg-white light-blue"
            style="border: dashed 1px #1990FF;" [disabled]="carenceSubstitute[activeUnion[activeList].shortName]"
            [style.opacity]="carenceSubstitute[activeUnion[activeList].shortName] ? '0.5' : '1'"
            [style.cursor]="carenceSubstitute[activeUnion[activeList].shortName] ? 'not-allowed' : 'pointer'"
            (click)="!carenceSubstitute[activeUnion[activeList].shortName] && addSubstituteCandidate(activeUnion[activeList].shortName)">
            <span class="bold">+</span> Ajouter un candidat suppléant
          </button>

          <div
            *ngIf="showSubstituteSearch[activeUnion[activeList].shortName] && !carenceSubstitute[activeUnion[activeList].shortName]">
            <div class="w-full border-box flex gap-10 align-items-center">
              <input type="text" [(ngModel)]="substituteSearchTerm[activeUnion[activeList].shortName]"
                class="w-full p-10 radius-10 border-box" style="border: solid 1px #1990FF;"
                placeholder="Rechercher un candidat..." />
              <img src="assets/close_24px.svg" alt="close" class="pointer"
                (click)="showSubstituteSearch[activeUnion[activeList].shortName] = false">
            </div>

            <div class="mt-10" style="max-height: 300px; overflow-y: auto;">
              <div
                *ngFor="let candidate of getFilteredCandidates(substituteSearchTerm[activeUnion[activeList].shortName], activeUnion[activeList].shortName, 'substitute')"
                class="p-10 pointer radius-5 mb-5" style="border: solid 1px #E8E8E8; background: #FAFAFA;"
                (click)="selectCandidate(candidate, 'substitute', activeUnion[activeList].shortName)">
                <p class="no-margin bold">{{candidate.firstName}} {{candidate.lastName}}</p>
                <p class="no-margin small-text gray">{{candidate.email}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="!isValidated" class="flex align-items-center gap-10 mt-10">
            <label class="dark-blue no-margin">
              <input type="checkbox" [(ngModel)]="carenceSubstitute[activeUnion[activeList].shortName]"
                (ngModelChange)="onCarenceSubstituteChange(activeUnion[activeList].shortName, $event)">
              Carence
            </label>
          </div>

        </div>
      </div>
    </div>
    <button *ngIf="!isValidated" class="bg-dark-blue w-full p-20 white bold radius-10 no-border"
      [disabled]="!canValidateCollege()" [style.opacity]="canValidateCollege() ? '1' : '0.5'"
      [style.cursor]="canValidateCollege() ? 'pointer' : 'not-allowed'"
      (click)="canValidateCollege() && validateCollegeCandidates()">
      Valider les candidats du collège {{index}}
    </button>
  </div>
</div>